import privacyPolicyCopyVietnam from "../../../../src/content/vietnam-christmas/privacyPolicy";
import customConfirmationVietname from "../../../../src/content/vietnam-christmas/customConfirmation.js";
import { GetInvolved } from '@bgea-js/form-templates';
import * as React from 'react';
export default {
  privacyPolicyCopyVietnam,
  customConfirmationVietname,
  GetInvolved,
  React
};